import React from "react";
import {Link} from "react-router-dom";

class Button extends React.Component {
  constructor(props) {
    super(props);
    this.state = {  };
  }
  render() { 
    let classes = `${this.props.classes} bg-orange border-0 rounded-md py-2 px-${this.props.padding} text-white font-t-bold uppercase`
    if (this.props.link) return (
      <button className={classes}>
        <Link to={this.props.link} >{this.props.label}</Link>
      </button>
    );
    return (
      <button className={classes} onClick={this.props.onButtonClick}>
        {this.props.label}
      </button>
    )
  }
}
 
export default Button;